import { Context } from '@nuxt/types'

export default (context: Context) => {
  // console.info(
  //   'middleware - authenticated context=',
  //   context,
  //   context.store.getters['AuthUserStore/authUser'],
  //   context.store.getters['AuthUserStore/lastLoginAt']
  // )
  context.store
    .dispatch('AuthUserStore/log', {
      level: 'info',
      message: 'minalib-front.page',
      context: {
        path: decodeURI(context.route.fullPath)
      }
    })
    .then()

  const authenticated = context.store.getters['AuthUserStore/authUser'].id > 0

  if (context.route.name === 'login') {
    if (authenticated) {
      return context.redirect('/')
    }
    return
  }

  if (authenticated) {
    context.store.dispatch('AuthUserStore/fetch').then()
    return
  }

  return context.redirect('/login')
}
